import {
    GET_DASHBOARD_DETAILS,
    GET_DASHBOARD_DETAILS_SUCCESS,
    GET_DASHBOARD_DETAILS_FAILURE,
    GET_BANNERS,
    GET_BANNERS_SUCCESS,
    GET_BANNERS_FAILURE,
    GET_INCBOT_INTERVIEW_MONTHLY_STATS,
    GET_INCBOT_INTERVIEW_MONTHLY_STATS_SUCCESS,
    GET_INCBOT_INTERVIEW_MONTHLY_STATS_FAILURE,
    GET_DASHBOARD_INTERVIEWS,
    GET_DASHBOARD_INTERVIEWS_SUCCESS,
    GET_DASHBOARD_INTERVIEWS_FAILURE,
    GET_FINAL_OUTCOMES,
    GET_FINAL_OUTCOMES_SUCCESS,
    GET_FINAL_OUTCOMES_FAILURE,
    GET_FEEDBACK_STATUS,
    GET_FEEDBACK_STATUS_SUCCESS,
    GET_FEEDBACK_STATUS_FAILURE,
    GET_POSITIONS_SUMMARY,
    GET_POSITIONS_SUMMARY_SUCCESS,
    GET_POSITIONS_SUMMARY_FAILURE,
    GET_TOP_POSITIONS,
    GET_TOP_POSITIONS_SUCCESS,
    GET_TOP_POSITIONS_FAILURE,
    GET_POSITION_ANALYTICS,
    GET_POSITION_ANALYTICS_SUCCESS,
    GET_POSITION_ANALYTICS_FAILURE,
    GET_INTERVIEW_COMPLETED,
    GET_INTERVIEW_COMPLETED_SUCCESS,
    GET_INTERVIEW_COMPLETED_FAILURE,
    GET_TOTAL_INTERVIEWS_FAILURE,
    GET_TOTAL_INTERVIEWS,
    GET_TOTAL_INTERVIEWS_SUCCESS,
    GET_INTERVIEW_COMPLETED_SUMMARY,
    GET_INTERVIEW_COMPLETED_SUMMARY_FAILURE,
    GET_INTERVIEW_COMPLETED_SUMMARY_SUCCESS,
    GET_WHATS_NEW,
    GET_WHATS_NEW_SUCCESS,
    GET_WHATS_NEW_FAILURE,
    GET_DASHBOARD_USER_POSITIONS,
    GET_DASHBOARD_USER_POSITIONS_SUCCESS,
    GET_DASHBOARD_USER_POSITIONS_FAILURE,
    GET_DASHBOARD_SUBUSER_LIST,
    GET_DASHBOARD_SUBUSER_LIST_SUCCESS,
    GET_DASHBOARD_SUBUSER_LIST_FAILURE,
} from '../action/types';
const INIT_STATE = {
    loading: false,
    lists: null,
    banners: null,
    interviewMonthlyStatsData: null,
    interviewData: null,
    interviewLoading: false,
    finalOutcomesData: null,
    finalOutcomesLoading: false,
    feedbackStatusData: null,
    feedbackStatusLoading: false,
    whatsNew: null,
    userPositions: [],
    userPositionsLoading: false,
    subuserList: [],
    subuserListLoading: false,
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_DASHBOARD_DETAILS:
            return { ...state, loading: true };
        case GET_DASHBOARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                lists: action.payload,
            };
        case GET_DASHBOARD_DETAILS_FAILURE:
            return { ...state, loading: false };

        case GET_BANNERS:
            return { ...state, loading: true };
        case GET_BANNERS_SUCCESS:
            return {
                ...state,
                loading: false,
                banners: action.payload,
            };
        case GET_BANNERS_FAILURE:
            return { ...state, loading: false };
        case GET_INCBOT_INTERVIEW_MONTHLY_STATS:
            return { ...state, loading1: true, interviewMonthlyStatsData: null };
        case GET_INCBOT_INTERVIEW_MONTHLY_STATS_SUCCESS:
            return {
                ...state,
                loading1: false,
                interviewMonthlyStatsData: action.payload,
            };
        case GET_INCBOT_INTERVIEW_MONTHLY_STATS_FAILURE:
            return { ...state, loading1: false, interviewMonthlyStatsData: null };

        case GET_DASHBOARD_INTERVIEWS:
            return { ...state, interviewLoading: true, interviewData: null };
        case GET_DASHBOARD_INTERVIEWS_SUCCESS:
            return {
                ...state,
                interviewLoading: false,
                interviewData: action.payload,
            };
        case GET_DASHBOARD_INTERVIEWS_FAILURE:
            return { ...state, interviewLoading: false };

        case GET_FINAL_OUTCOMES:
            return { ...state, finalOutcomesLoading: true };
        case GET_FINAL_OUTCOMES_SUCCESS:
            return {
                ...state,
                finalOutcomesLoading: false,
                finalOutcomesData: action.payload,
            };
        case GET_FINAL_OUTCOMES_FAILURE:
            return { ...state, finalOutcomesLoading: false };

        case GET_FEEDBACK_STATUS:
            return { ...state, feedbackStatusLoading: true };
        case GET_FEEDBACK_STATUS_SUCCESS:
            return {
                ...state,
                feedbackStatusLoading: false,
                feedbackStatusData: action.payload,
            };
        case GET_FEEDBACK_STATUS_FAILURE:
            return { ...state, feedbackStatusLoading: false };

        case GET_POSITIONS_SUMMARY:
            return { ...state, positionsSummaryLoading: true };
        case GET_POSITIONS_SUMMARY_SUCCESS:
            return {
                ...state,
                positionsSummaryLoading: false,
                positionsSummaryData: action.payload,
            };
        case GET_POSITIONS_SUMMARY_FAILURE:
            return { ...state, positionsSummaryLoading: false };

        case GET_TOP_POSITIONS:
            return { ...state, loading4: true };
        case GET_TOP_POSITIONS_SUCCESS:
            return {
                ...state,
                loading4: false,
                topPositionsData: action.payload,
            };
        case GET_TOP_POSITIONS_FAILURE:
            return { ...state, loading4: false };

        case GET_POSITION_ANALYTICS:
            return { ...state, positionAnalyticsLoading: true };
        case GET_POSITION_ANALYTICS_SUCCESS:
            return {
                ...state,
                positionAnalyticsLoading: false,
                positionAnalyticsData: action.payload,
            };
        case GET_POSITION_ANALYTICS_FAILURE:
            return { ...state, positionAnalyticsLoading: false };

        case GET_INTERVIEW_COMPLETED:
            return { ...state, interviewCompletedLoading: true };
        case GET_INTERVIEW_COMPLETED_SUCCESS:
            return {
                ...state,
                interviewCompletedLoading: false,
                interviewCompletedData: action.payload,
            };
        case GET_INTERVIEW_COMPLETED_FAILURE:
            return { ...state, interviewCompletedLoading: false };
        case GET_TOTAL_INTERVIEWS:
            return { ...state, totalInterviewsLoading: true, totalInterviewsData: null };
        case GET_TOTAL_INTERVIEWS_SUCCESS:
            return {
                ...state,
                totalInterviewsLoading: false,
                totalInterviewsData: action.payload,
            };
        case GET_TOTAL_INTERVIEWS_FAILURE:
            return { ...state, totalInterviewsLoading: false };
        case GET_INTERVIEW_COMPLETED_SUMMARY:
            return { ...state, interviewCompletedSummaryLoading: true, interviewCompletedSummaryData: null };
        case GET_INTERVIEW_COMPLETED_SUMMARY_SUCCESS:
            return { ...state, interviewCompletedSummaryLoading: false, interviewCompletedSummaryData: action.payload };
        case GET_INTERVIEW_COMPLETED_SUMMARY_FAILURE:
            return { ...state, interviewCompletedSummaryLoading: false };
        case GET_WHATS_NEW:
            return { ...state, loading: true };
        case GET_WHATS_NEW_SUCCESS:
            return { ...state, loading: false, whatsNew: action.payload };
        case GET_WHATS_NEW_FAILURE:
            return { ...state, loading: false };

        case GET_DASHBOARD_USER_POSITIONS:
            return { ...state, userPositionsLoading: true };
        case GET_DASHBOARD_USER_POSITIONS_SUCCESS:
            return { ...state, userPositionsLoading: false, userPositions: action.payload };
        case GET_DASHBOARD_USER_POSITIONS_FAILURE:
            return { ...state, userPositionsLoading: false };

        case GET_DASHBOARD_SUBUSER_LIST:
            return { ...state, subuserListLoading: true };
        case GET_DASHBOARD_SUBUSER_LIST_SUCCESS:
            return { ...state, subuserListLoading: false, subuserList: action.payload };
        case GET_DASHBOARD_SUBUSER_LIST_FAILURE:
            return { ...state, subuserListLoading: false };

        default:
            return state;
    }
};
